<script>
import { inject, onMounted, onUnmounted, reactive, useSlots } from 'vue'

export default {
    props: {
        uid: { type: String, default: () => crypto.randomUUID() },
        fullName: { type: String },
        jobTitle: { type: String },
    },
    setup(props) {
        const { register, unregister } = inject('testimonial-slider', { register: ()=>{}, unregister: ()=>{} })

        const testimonialItem = reactive({
            uid: props.uid,
            fullName: props.fullName,
            jobTitle: props.jobTitle,
            image: null,
            text: null,
        })

        const slots = useSlots()

        onMounted(() => {
            if (slots.image) {
                testimonialItem.image = slots.image()
            }
            if (slots.default) {
                testimonialItem.text = slots.default()
            }

            register(testimonialItem)
        })
        onUnmounted(() => { unregister(testimonialItem) })

        return () => null
    }
}
</script>
